module.exports = __webpack_public_path__ + "img/logo.e08a182d.svg";